export default __webpack_public_path__ + "static/media/likeUnselected.f28c7855.svg";